import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import ModalSelecaoLimite from "components/modal/periodicidade/ModalSelecaoLimite";
import ModalSelecaoPeriodicidade from "components/modal/periodicidade/ModalSelecaoPeriodicidade";
import Setor from "model/administracao/cadastro/Setor";
import Usuario from "model/administracao/cadastro/Usuario";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import SetorPlanoAuditoria from "model/auditoria5s/planoDeAuditoria/SetorPlanoAuditoria";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import SetorService from "service/administracao/cadastro/SetorService";
import { PeriodicidadeService } from "service/periodicidade/PeriodicidadeService";
import { defaultCompleteMethod } from "utils/autocompleteUtils";

const setorService = new SetorService();
const periodicidadeService = new PeriodicidadeService();

export default function SetorCadastro() {

    const { setError, formState: { errors }, register, clearErrors } = useForm();

    const [queryParameters] = useSearchParams();
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [planos, setPlanos] = useState<PlanoAuditoria[]>([]);
    const [planosFiltrados, setPlanosFiltrados] = useState<PlanoAuditoria[]>([]);
    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);
    const [dialogPediodicidade, setDialogPediodicidade] = useState<{ visible: boolean, data: any, originalData: any }>({ visible: false, data: null, originalData: null });
    const [dialogLimite, setDialogLimite] = useState<{ visible: boolean, data: any, originalData: any }>({ visible: false, data: null, originalData: null });
    const titulo = "Cadastro de Setor";

    useEffect(() => {
        const idConta = queryParameters.get('idConta');
        if (idConta) {
            setorService.usuarios(parseInt(idConta)).then(resposta => {
                setUsuarios([new Usuario(-1, null, 'Selecione'), ...resposta])
            }).catch((error) => {
                console.error("Erro ao buscar usuarios:", error);
            });
            setorService.planos(parseInt(idConta)).then((resposta) => {
                setPlanos(resposta)
            }).catch((error) => {
                console.error("Erro ao buscar planos:", error);
            });
            setorService.unidadesOrgan(parseInt(idConta)).then((resposta) => {
                setUnidades([new UnidadeOrganizacional(-1, null, -1, "Selecione..."), ...resposta])
            }).catch((error) => {
                console.error("Erro ao buscar unidades:", error);
            });
        } else {
            setorService.usuarios().then(resposta => {
                setUsuarios([new Usuario(-1, null, 'Selecione'), ...resposta])
            }).catch((error) => {
                console.error("Erro ao buscar usuarios:", error);
            });
            setorService.planos().then((resposta) => {
                setPlanos(resposta)
            }).catch((error) => {
                console.error("Erro ao buscar planos:", error);
            });
            setorService.unidadesOrgan().then((resposta) => {
                setUnidades([new UnidadeOrganizacional(-1, null, -1, "Selecione..."), ...resposta])
            }).catch((error) => {
                console.error("Erro ao buscar unidades organizacionais:", error);
            });
        }

    }, [])

    const [setor, setSetor] = useState<Setor>(new Setor());

    function validar() {

        if (!setor.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    const editorPlanoAuditoria = (options: ColumnEditorOptions) => {
        return <AutoComplete
            className="col col-sm-12"
            suggestions={planosFiltrados}
            field="nome"
            itemTemplate={(item) => <span>{item.nome} <span style={{ color: "#dc3545" }}>{(item.ativo ? '' : ' (Inativo)')}</span></span>}
            dropdown
            completeMethod={(e) => {
                setPlanosFiltrados(defaultCompleteMethod(planos, e.query, "nome") as PlanoAuditoria[])
            }}
            value={options.rowData.planoAuditoria}
            style={{ width: '100%' }}
            inputStyle={{ width: '100%' }}
            onChange={(e) => {
                setor.planos[options.rowIndex].planoAuditoria = e.value as PlanoAuditoria;
                options.rowData.planoAuditoria = e.value as PlanoAuditoria;
                setSetor({ ...setor })
            }}
        />
    }

    const editorResponsavel = (options: ColumnEditorOptions) => {
        return <Dropdown
            className="col col-sm-12"
            options={usuarios}
            filter
            optionLabel="nome"
            valueTemplate={(option: Usuario) => option ? option.nome : "Selecione"}
            value={options.rowData.responsavelAuditoria || usuarios[0]}
            style={{ width: '100%' }}
            onChange={(e) => {
                if (e.value.id === -1) {
                    setor.planos[options.rowIndex].auditor = null;
                    options.rowData.responsavelAuditoria = null;
                }
                else {
                    setor.planos[options.rowIndex].auditor = e.value as Usuario;
                    options.rowData.responsavelAuditoria = e.value as Usuario;
                }
                setSetor({ ...setor })
            }}
        />
    }

    return (

        <BaseCadastro model={setor} service={setorService} setModel={(value: Setor) => setSetor(value)} validar={() => validar()} urlService="/setor" pathCadastro="/setor" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            {dialogPediodicidade.visible ?
                <ModalSelecaoPeriodicidade visible={dialogPediodicidade.visible} value={dialogPediodicidade.data.periodicidade}
                    onChange={(value) => {
                        dialogPediodicidade.data.periodicidade = value
                        setSetor({ ...setor })
                    }}
                    onConfirm={() => {
                        setDialogPediodicidade({ visible: false, data: null, originalData: null })
                    }}
                    onCancel={() => {
                        dialogPediodicidade.data.periodicidade = dialogPediodicidade.originalData.periodicidade
                        setSetor({ ...setor })
                        setDialogPediodicidade({ visible: false, data: null, originalData: null })
                    }}
                />
                : null}
            {dialogLimite.visible ?
                <ModalSelecaoLimite visible={dialogLimite.visible} value={dialogLimite.data.limite}
                    onChange={(value) => {
                        dialogLimite.data.limite = value
                        setSetor({ ...setor })
                    }}
                    onConfirm={() => {
                        setDialogLimite({ visible: false, data: null, originalData: null })
                    }}
                    onCancel={() => {
                        dialogLimite.data.limite = dialogLimite.originalData.limite
                        setSetor({ ...setor })
                        setDialogLimite({ visible: false, data: null, originalData: null })
                    }}
                />
                : null}
            <div style={{ display: "flex", marginTop: 4 }}>
                <Checkbox
                    checked={setor.geraAuditoriaApp}
                    onChange={(e) => { setSetor({ ...setor, geraAuditoriaApp: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Permite gerar auditoria pelo App</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={setor.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setSetor({ ...setor, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Responsável</Label>
                <div className="col-sm-12">
                    <Dropdown
                        className="col col-sm-12"
                        options={usuarios}
                        filter
                        key={"id"}
                        optionValue="id"
                        optionLabel="nome"
                        valueTemplate={(option: Usuario) => option ? option.nome : "Selecione"}
                        value={setor.responsavel?.id || -1}
                        style={{ width: '100%' }}
                        onChange={(e) => {
                            if (e.value === -1) {
                                setSetor({ ...setor, responsavel: null })
                            }
                            else {
                                let responsavel = usuarios.find(u => u.id === e.value)
                                setSetor({ ...setor, responsavel: responsavel as Usuario })
                            }
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Auditor</Label>
                <div className="col-sm-12">
                    <Dropdown
                        className="col col-sm-12"
                        options={usuarios}
                        filter
                        key={"id"}
                        optionValue="id"
                        optionLabel="nome"
                        valueTemplate={(option: Usuario) => option ? option.nome : "Selecione"}
                        value={setor.auditor?.id || -1}
                        style={{ width: '100%' }}
                        onChange={(e) => {
                            if (e.value === -1) {
                                setSetor({ ...setor, auditor: null })
                            }
                            else {
                                let auditor = usuarios.find(u => u.id === e.value)
                                setSetor({ ...setor, auditor: auditor as Usuario })
                            }
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <Label className="col col-sm-12">Unidade Organizacional</Label>
                <div className="col-sm-12">
                    <Dropdown
                        className="col col-sm-12"
                        options={unidades}
                        key={"id"}
                        optionValue="id"
                        optionLabel="nome"
                        valueTemplate={(option: UnidadeOrganizacional) => option ? option.nome : "Selecione"}
                        value={setor.unidadeOrganizacional?.id || -1}
                        style={{ width: '100%' }}
                        onChange={(e) => {
                            if (e.value === -1) {
                                setSetor({ ...setor, unidadeOrganizacional: null })
                            }
                            else {
                                let unidade = unidades.find(u => u.id === e.value)
                                setSetor({ ...setor, unidadeOrganizacional: unidade as UnidadeOrganizacional })
                            }
                        }}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <BaseDataTableEdit
                        isSelection={false}
                        tituloLista="Planos de auditoria"
                        getNewModel={() => new SetorPlanoAuditoria()}
                        dataKey="key"
                        lista={setor.planos ? setor.planos : []}
                        setLista={(value: any) => setSetor({ ...setor, planos: value })}
                        scrollable
                        scrollHeight='500px'
                    >
                        <Column
                            field="planoAuditoria" header="Plano de auditoria"
                            style={{ width: '50%' }}
                            body={(rowData: SetorPlanoAuditoria) => <span>{rowData.planoAuditoria?.nome} <span style={{ color: "#dc3545" }}>{(rowData.planoAuditoria?.ativo ? '' : ' (Inativo)')}</span></span> }
                            editor={editorPlanoAuditoria}
                        />
                        <Column
                            field="auditor" header="Auditor"
                            style={{ width: '15%' }}
                            body={(rowData: SetorPlanoAuditoria) => rowData.auditor ? rowData.auditor.nome : "Selecione"}
                            editor={editorResponsavel}
                        />
                        <Column
                            style={{ width: '10%' }}
                            header="Periodicidade"
                            body={(rowData: SetorPlanoAuditoria) => <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                {rowData.periodicidade?.ativa ?
                                    rowData.periodicidade.personalizada ? "Personalizada" : rowData.periodicidade.periodo + " " + periodicidadeService.getTipoPeriodo(rowData.periodicidade.tipoPeriodo)?.label
                                    : "Inativa"}
                                <Button onClick={() => {
                                    setDialogPediodicidade({ visible: true, data: rowData, originalData: JSON.parse(JSON.stringify(rowData)) });
                                }} icon={<FontAwesomeIcon icon="edit" />} />
                            </div>}
                        />
                        <Column
                            style={{ width: '10%' }}
                            header="Limite"
                            body={(rowData: SetorPlanoAuditoria) => <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                {rowData.limite?.ativa ?
                                    rowData.limite.periodo + " " + periodicidadeService.getTipoPeriodo(rowData.limite.tipoPeriodo)?.label
                                    : "Inativa"}
                                <Button onClick={() => {
                                    setDialogLimite({ visible: true, data: rowData, originalData: JSON.parse(JSON.stringify(rowData)) });
                                }} icon={<FontAwesomeIcon icon="edit" />} />
                            </div>}
                        />
                        <Column header="Pode gerar no app"
                            body={(rowData: SetorPlanoAuditoria) => <Checkbox checked={rowData.geraAuditoriaApp as boolean} onChange={(e) => {
                                rowData.geraAuditoriaApp = e.checked as boolean;
                                setSetor({ ...setor })
                            }} />}
                            style={{ width: '15%', textAlign: "center" }} />
                    </BaseDataTableEdit>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <DataTable value={setor.emailsEnviar?.map(email => ({ email }))} scrollable scrollHeight='500px' emptyMessage="Nenhum registro encontrado"
                        header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                            <div></div>
                            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Emails de destino</span>
                            <div>
                                <Button
                                    type="button" icon={<FontAwesomeIcon icon="add" />}
                                    tooltip="Adicionar"
                                    tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => setSetor({ ...setor, emailsEnviar: [...(setor.emailsEnviar || []), ""] })}
                                ></Button>
                            </div>
                        </div>}
                    >
                        <Column field="email" header="Email" style={{ width: '100%' }} body={(rowData, options) => {
                            return <InputText value={rowData.email} style={{ width: '100%' }} onChange={(e) => {
                                if (setor.emailsEnviar) {
                                    setor.emailsEnviar[options.rowIndex] = e.target.value;
                                    setSetor({ ...setor });
                                }
                            }} />
                        }} />
                        <Column style={{ width: '100%' }} body={(rowData, options) => <Button icon={<FontAwesomeIcon icon="trash" />} onClick={(e) => {
                            if (setor.emailsEnviar) {
                                setor.emailsEnviar.splice(options.rowIndex, 1);
                                setSetor({ ...setor });
                            }
                        }} />} />
                    </DataTable>
                </div>
            </div>

        </BaseCadastro>
    )
}
